var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import InfoTitle from './InfoTitle';
import InfoItem from './InfoItem';
import Box from '../Box';
var InfoList = function (props) {
    var _a;
    var data = props.data, title = props.title, loading = props.loading, rows = props.rows, titleProps = props.titleProps;
    return (React.createElement(Box, { loading: loading, sx: {
            border: '1px solid #ededed'
        } },
        title && React.createElement(InfoTitle, __assign({ title: title }, titleProps)),
        React.createElement(Box, null, (_a = (rows || [])) === null || _a === void 0 ? void 0 : _a.map(function (n) { return (React.createElement(InfoItem, { key: n.id, row: n, data: data ? data[n.id] : '' })); }))));
};
InfoList.defaultProps = {
    data: {},
    loading: false
};
export default InfoList;
